import { graphql, useStaticQuery } from "gatsby";
    import { PatstorePerson } from '@types';

const useGetPerson = () => {
    const data = useStaticQuery(graphql`
        query AllPerson {
            allPatstorePerson {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    portrait
    email
    description
    image
    data
    
                    }
                }
            }
        }
    
        `);


    const allPerson: PatstorePerson[] =
        data.allPatstorePerson.edges.map(
            (edge: { node: PatstorePerson }) => edge.node
        ) || [];

    const findPerson: (id: string) => PatstorePerson | undefined = (id: string) => {
        const result = allPerson.find((item: PatstorePerson) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findPerson,
        persons: allPerson,
    };
}; 

export default useGetPerson;
